<template>
    <div>
        <br/>
        <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
        <div class="field">
            <b-input
                    v-model="searchFilter"
                    placeholder="Search for users containing this text...">
            </b-input>
        </div>
        <b-table
                :data="adminUsers"
                v-if="adminUsers"
                :row-class="getRowClass"
                :default-sort="['name', 'asc']"
        >
            <template slot-scope="props">
                <b-table-column class="centered-table-content" field="tenantId" label="Tenant Code" sortable>
                    {{props.row.tenantId}}
                </b-table-column>
                <b-table-column class="centered-table-content" field="login" label="Login" sortable>
                    {{props.row.login}}
                </b-table-column>
                <b-table-column class="centered-table-content" field="type" label="Type" sortable>
                    <b-tag :type="props.row.type === 'admin' ? 'is-info' : 'is-danger'">
                        <span>{{ props.row.type }}</span>
                    </b-tag>
                </b-table-column>
                <b-table-column class="centered-table-content" label="Active?">
                    <b-tag :type="props.row.isActive ? 'is-success' : 'is-danger'">
                        <span>{{ props.row.isActive ? 'Yes' : 'No' }}</span>
                    </b-tag>
                </b-table-column>
                <b-table-column class="centered-table-content" field="action" label="">
                    <button @click="editAdminUser(props.row.userId)" style="margin-left: 5px;"
                            class="button is-outlined">
                        Edit
                    </button>
                </b-table-column>
                <b-table-column class="centered-table-content" field="action" label="">
                    <button @click="confirmDeleteAdminUser(props.row.userId)" style="margin-left: 5px;"
                            class="button is-danger is-outlined">
                        Delete
                    </button>
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>

<script>
    import {DialogProgrammatic as Dialog} from 'buefy'
    import adminUserService from '../../services/adminUsersService'
    import {DeleteError} from '../../errors/DeleteError'

    import textutils from '../../helpers/text-helper'
    import displayHelper from '../../helpers/display-helper'

    export default {
        name: 'adminUser-table',
        created() {
            this.loadAdminUserList()
        },
        data() {
            return {
                isLoading: true,
                deleteError: null,
                adminUsers: null,
                columns: [
                    {
                        field: 'tenantId',
                        label: 'AdminUser TenantId',
                    },
                    {
                        field: 'login',
                        label: 'Login',
                    },
                    {
                        field: 'isActive',
                        label: 'Active?',
                    },
                ],
                searchFilter: null,
            }
        },
        filters: {
            truncate(value, length) {
                return textutils.truncate(value, length)
            },
        },
        methods: {
            getRowClass(row, index) {
                if (this.searchFilter && this.searchFilter !== '') {
                    let found = false
                    let searchLower = this.searchFilter.toLowerCase()
                    for (let col of this.columns) {
                        if (row[col.field] && row[col.field].toString().toLowerCase().indexOf(searchLower) >= 0) {
                            found = true
                        }
                    }
                    if (found === false) {
                        return 'is-hidden'
                    }
                }
            },
            loadAdminUserList() {
                const parent = this
                adminUserService.getAdminUsers()
                    .then((adminUsers) => {
                            this.adminUsers = adminUsers
                        },
                        (err) => {
                            this.isError = true
                            displayHelper.displayError(parent, 'Oops, the adminUsers could not be listed: ' + err.message)
                        })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            editAdminUser(userId) {
                this.$router.push({name: 'EditAdminUserForm', params: {id: userId}})
            },
            deleteAdminUser(userId) {
                const parent = this
                this.isLoading = true
                this.isError = false
                adminUserService.deleteAdminUser(userId)
                    .then(() => {
                        displayHelper.displaySuccess(parent, 'AdminUser successfully deleted')
                    })
                    .catch((err) => {
                        console.log('Error Message', err.message)
                        if (err instanceof DeleteError) {
                            displayHelper.displayError(parent, 'This adminUser could not be deleted: ' + err.names.join(', '))
                        } else {
                            this.isError = true
                            displayHelper.displayError(parent, 'Error while deleting the adminUser: ' + err.message)
                        }
                    })
                    .finally(() => {
                        this.loadAdminUserList()
                    })
            },
            confirmDeleteAdminUser(userId) {
                Dialog.confirm({
                    message: 'Warning! This will delete this Admin User. Are you sure you want to proceed?',
                    onConfirm: () => this.deleteAdminUser(userId)
                })
            }
        }
    }
</script>
